import { ParserId } from "../Parsers/IParser";
import { IImportExample } from "./IImportExample";


export interface IImportExampleService {
    getImportExamples(): IImportExample[]
}

export class ImportExampleService implements IImportExampleService {
    getImportExamples(): IImportExample[] {
        return [
            { id: "1", name: "CSV example 1", parserId: ParserId.Csv, url: "examples/example1.csv" },
            { id: "2", name: "JSON example 1", parserId: ParserId.Json, url: "examples/example1.json" },
        ];
    }
}